<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <h2 class="noMarginHeader">
            <mat-icon>bar_chart</mat-icon> Reports
        </h2><br />
    </div>
</div>

<ul>
    <li>
        <a href="{{env.powerbiLink}}" title="Tableau Reports" target="_blank">Power BI Reports</a> 
    </li>
    <br>
    <li>
        <a routerLink="/pending-access-updates" title="Pending Access Updates">Pending Access Updates</a>
    </li>
</ul>